module.exports = __webpack_public_path__ + "img/mask.69cb3d25.png";